﻿[<AutoOpen>]
module Sm.UI.Components.Util

open System.Text.RegularExpressions

open Browser.Types
open Fable.Core
open Fable.Core.JsInterop
open Fable.React
open Fable.React.Props

open Sm.UI.Form
open Sm.UI.InputParser

type ClassOp =
    | Append of string
    | Toggle of string * bool
    | Optional of string option

let renderClassList items =
    ("", items) ||> List.fold (fun a item ->
        let append x = sprintf "%s %s" a x

        match item with
        | Append name -> append name
        | Toggle (name, true) -> append name
        | Toggle (_, false) -> a
        | Optional (Some name) -> append name
        | Optional None -> a
    )

let iconFor name (props: IHTMLProp list) =
    let p = keyValueList CaseRules.LowerFirst props

    match name with
    | ArrowLeft -> ofImport "default" "./../../images/arrow-left.svg" p []
    | ArrowRight -> ofImport "default" "./../../images/arrow-right.svg" p []
    | BannerLogo -> ofImport "default" "./../../images/banner-logo.svg" p []
    | Box -> ofImport "default" "./../../images/box.svg" p []
    | Calendar -> ofImport "default" "./../../images/calendar.svg" p []
    | Cross -> ofImport "default" "./../../images/cross.svg" p []
    | CrossSubtle -> ofImport "default" "./../../images/cross-subtle.svg" p []
    | Loading -> ofImport "default" "./../../images/loading.svg" p []
    | Logo -> ofImport "default" "./../../images/logo.svg" p []
    | Offline -> ofImport "default" "./../../images/offline.svg" p []
    | Pause -> ofImport "default" "./../../images/pause.svg" p []
    | Play -> ofImport "default" "./../../images/play.svg" p []
    | Revert -> ofImport "default" "./../../images/revert.svg" p []
    | Run -> ofImport "default" "./../../images/run.svg" p []
    | Sync -> ofImport "default" "./../../images/sync.svg" p []
    | SyncDown -> ofImport "default" "./../../images/sync-down.svg" p []
    | SyncError -> ofImport "default" "./../../images/sync-error.svg" p []
    | SyncOk -> ofImport "default" "./../../images/sync-ok.svg" p []
    | SyncUp -> ofImport "default" "./../../images/sync-up.svg" p []
    | Tick -> ofImport "default" "./../../images/tick.svg" p []
    | Tools -> ofImport "default" "./../../images/tools.svg" p []
    | Trophy -> ofImport "default" "./../../images/trophy.svg" p []
    | Warning -> ofImport "default" "./../../images/warning.svg" p []
    | Zzz -> ofImport "default" "./../../images/zzz.svg" p []

let renderSyntax nodes =
    nodes
    |> List.map(function
        | Link url ->
            let protocol = Regex(@"^https?:\/\/")
            let www = Regex(@"^www\.")
            let slash = Regex(@"\/$")
            let remove (re: Regex) s = re.Replace(s, "")

            let text =
                url
                |> remove protocol
                |> remove www
                |> remove slash

            let href =
                if protocol.IsMatch(url) then url
                else $"https://{url}"

            a [Class "syntax syntax-link"; Href href; Target "_blank"; Rel "noopener"] [str text]

        | Text s -> span [Class "syntax syntax-text"] [str s]
        | Tag t -> span [Class "syntax syntax-tag"] [str t]
        | Timer i -> span [Class "syntax syntax-timer"] [strf "%i" i]
        | Directive args ->
            span [Class "syntax syntax-directive"] (
                args
                |> List.map (function
                    | Dimension (value, unit) -> span [Class "syntax arg-dimension"] [strf "%i%s" value unit]
                    | Number n -> span [Class "syntax arg-number"] [strf "%i" n]
                    | Ident w -> span [Class "syntax arg-ident"] [str w]
                    | Unrecognised x -> span [Class "syntax arg-unrecognised"] [str x]
                )
            )
        | ResourceAttribute (name, value) ->
            span [Class "syntax syntax-resource"] [
                span [Class "syntax resource-name"] [str name]
                span [Class "syntax resource-value"] [str value]
            ]
    )


let (|HTMLInputElement|_|) (actual: Element) =
    if isNull actual then
        None
    else if actual.tagName = "INPUT" then
        Some (actual :?> HTMLInputElement)
    else
        None

let (|HTMLTextAreaElement|_|) (actual: Element) =
    if isNull actual then
        None
    else if actual.tagName = "TEXTAREA" then
        Some (actual :?> HTMLTextAreaElement)
    else
        None

let (|HTMLDivElement|_|) (actual: Element) =
    if isNull actual then
        None
    else if actual.tagName = "DIV" then
        Some (actual :?> HTMLDivElement)
    else
        None

let (|HTMLElement|_|) (actual: obj) =
    if isNull actual then
        None
    else if emitJsExpr actual "$0 instanceof HTMLElement" then
        Some (actual :?> HTMLElement)
    else
        None

